import axios from "axios";

const backendURL = process.env.REACT_APP_BACKEND_URL?.replace(/\/+$/, "");
if (!backendURL) throw new Error("REACT_APP_BACKEND_URL is required");

export const api = axios.create({ baseURL: `${backendURL}/api`, withCredentials: true });

export function formatError(error) {
  const detail = error?.response?.data?.detail;
  return Array.isArray(detail) ? detail.map((x) => String(x.msg).replace(/^Value error, /, "")).join(" ") : detail || "Something went wrong. Please try again.";
}
